import { useWindowStore } from '@/stores/useWindowStore';
import { useThrottledValue } from '@tanstack/react-pacer';
import { useMemo } from "react";
import { ScrollView, StyleSheet, View } from 'react-native';

const usePlattformStyles = ({isDesktop, isNative, isFluid, maxWidth = 1750}) => {

    const { width: windowWidth } = useWindowStore((s) => s.dimensions);
    const [throttleWindowWidth] = useThrottledValue(windowWidth, {
        wait: 2500, leading: true, trailing: true
    });

    return useMemo(() => {
        let styles = {
            width: '100%',
            maxWidth: '100%',
        };

        if (isDesktop) {
            styles = {
                width: isFluid ? '100%' : throttleWindowWidth - 100,
                maxWidth: isFluid ? '100%' : maxWidth,
                alignSelf: 'center',
            };
        }

        if (isNative) {
            
        }

        return styles;
    }, [throttleWindowWidth, isDesktop, isNative, isFluid, maxWidth]);
}

export const Container = (props) => {

    const isDesktop = useWindowStore((s) => s.isDesktop);
    const isNative = useWindowStore((s) => s.isNative);
    
    const {style = {}, isFluid = false, scollable = false, maxWidth = 1750, ...rest} = props;

    const platformStyles = usePlattformStyles({isDesktop, isNative, isFluid, maxWidth});

    if (!isNative) 
        return <View className={"Container"} style={StyleSheet.flatten([platformStyles, style])} {...rest} />

    if (scollable)
        return <ScrollView style={StyleSheet.flatten([platformStyles, style])} {...rest} />;

    return <View style={StyleSheet.flatten([platformStyles, style])} {...rest} />;

};
